import { Delete } from '@/components/Icons'

import messages from './messages'

export default ({ intl, showConfirmDelete, currentUser }: any) => [
  {
    property: 'displayName',
    header: {
      label: intl.formatMessage(messages.name),
      sortable: true
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="keyvalues__label">{rowData.displayName}</span>]
    }
  },
  {
    property: 'email',
    header: {
      label: intl.formatMessage(messages.email)
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="sub-text">{rowData.email}</span>]
    }
  },
  {
    property: 'id',
    cell: {
      props: {
        style: {
          width: 50
        }
      },
      formatters: [
        // TOOD Remove this onClick and wrap it in a button
        (id: any, { rowData }: any) =>
          currentUser.id !== rowData.id && <Delete onClick={() => showConfirmDelete(rowData)} />
      ]
    }
  }
]
